<template>
    <div class="home-container" :class="{'menu-open':isMenuOpen}">
    <div class="menu-overlay" v-on:click="isMenuOpen=false"></div>
        <div class="home-container-inner">
            <div class="home-header">
                <div class="home-header-inner">
                    <div class="left-logo">
                        <a href="javascript:;">EVENTSCODED</a>
                    </div>
                    <div class="right-part">
                        <ul class="unstyled-list menu-listing">
                            <li>
                                <a href="javascript:;">Home</a>
                            </li>
                            <li>
                            <button v-on:click="openMenu()">
                                <i class="fa fa-bars" aria-hidden="true"></i>
                            </button>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>

            <div class="home-body">
                <div class="home-body-inner">
                    <h2 class="welcome-text text-center">Registration & Event Management Software. Manage your conference with ease.</h2>

                    <h3 class="main-heading text-center">{{displayText}}</h3>
                    <p class="reach-us-email text-center"><strong>Reach us:</strong> info@eventscoded.com</p>
                    <p class="text-center m-0">
                        <router-link to="/login">
                            <button class="login-btn">LOGIN</button>
                        </router-link>
                    </p>
                </div>
            </div>
            <div class="sidebar-menu-container">
            <button class="sidebar-close-btn"  v-on:click="isMenuOpen=false"><i class="fa fa-times" aria-hidden="true"></i></button>
                    <h4 class="menu-title">EVENTSCODED</h4>
                    <p class="reach-us-email text-left"><strong>Reach us:</strong> info@eventscoded.com</p>
        </div>
        </div>
        
    </div>
    
</template>

<script>

export default {
    data () {
        return {
            isMenuOpen: false,
            textArr: ['dynamic.', 'flexible.', 'creative.', 'simple.'],
            displayText: 'dynamic.'
        }
    },
    mounted(){
        this.textChanger()
    },
    methods: {
        textChanger: function(){
            let self = this
            let counter = 0;
            setInterval(()=>{
                this.displayText = this.textArr[counter];
                counter++
                if(counter>=this.textArr.length)
                    counter=0;
            }, 3000);
        },
        openMenu: function(){
            this.isMenuOpen = true;
        }
    }
};
</script>
<style>
@import url('https://fonts.googleapis.com/css?family=Roboto:300,400,500,700|Source+Sans+Pro:400,600&display=swap');

/*font-family: 'Source Sans Pro', sans-serif;
font-family: 'Roboto', sans-serif;*/
button{
    cursor:pointer;
}
button:focus{
    outline: none;
}
.sidebar-close-btn{
    background: transparent;
    border: none;
    color: #fff;
    font-size: 18px;
    position: absolute;
    right: 3px;
    top: 3px;
    display: none;
}
    .login-btn {
        border: 2px solid #444;
        background-color: transparent;
        line-height: 36px;
        font-weight: 700;
        text-shadow: none;
        font-weight: 400;
        letter-spacing: 2px;
        font-size: 13px;
        border-color: #F9F9F9;
        color: #F9F9F9;
        border-radius: 28px;
        font-family: 'Roboto', sans-serif;
        padding: 0px 25px;
        margin-top: 35px;
        cursor:pointer;
    }
    .login-btn:hover{
        background-color: #F9F9F9;
        color: #333;
    }
    .home-body{
        height: calc(100vh - 76px);
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .unstyled-list{
        list-style: none;
        padding:0;
        margin:0;
    }
    .menu-listing li button{
        list-style: none;
        padding: 0;
        margin: 0;
        color:#fff;
        background: transparent;
        border: none;
    }
    .menu-listing{
        display: flex;
        justify-content: flex-end;
    }
    .menu-listing li{
        padding: 7px 22px;
    }
    .menu-listing li:last-child{
        padding-right: 0;
    }
    .menu-listing li a{
        font-size: 14px;
        font-weight: 600;
        letter-spacing: 3px;
        font-family: 'Source Sans Pro', sans-serif;
        color: #EEE;
        text-shadow: 1px 1px 1px rgba(0,0,0,0.1);
        text-transform: uppercase;
    }
    .menu-listing li a:hover{
        text-decoration:none;
    }
    .home-container{
        background-color: rgba(0,0,0,0.5);
        height: 100vh;
        background-image: url(../assets/images-home/main.jpg);
        /*background-position: left -155px;*/
        background-size: cover;
        /*background-attachment: fixed*/
        position: relative;
        transition: all 0.6s;
        background-repeat: no-repeat;
    }
    .home-container-inner{
        background-color: rgba(0,0,0,0.6);
        height: 100%;
        width: 100%;
        min-width: 100%;
        transition:all 0.5s;
        position: relative;
    }
    .menu-open .home-container-inner{
       transform: translateX(-300px);
    }
    .home-header{
        padding: 16px 30px;
        border-bottom: 1px solid rgba(255,255,255,0.15) !important;
    }
    .home-header-inner{
        display: flex;
        align-items: center;
    }
    .left-logo{
        width: 160px;
    }
    .right-part{
        width: calc(100% - 160px);
    }
    .left-logo a{
        font-family: 'Source Sans Pro', sans-serif;
        color: #EEE;
        font-weight: 600;
        font-size: 20px;
        letter-spacing: 2px;
        line-height: 21px;
        text-transform: uppercase;
    }
    .main-heading{
        font-size: 115px;
        font-family: 'Roboto', sans-serif;
        font-weight: 700;
        color: #fff;
        margin-bottom: 13px;
    }
    .welcome-text{
        font-size: 1.25rem;
        font-weight: 300;
        font-family: 'Roboto', sans-serif;
        color: #fff;
        margin-bottom: 48px;
    }
    .reach-us-email{
        color: #EEE;
        font-family: 'Roboto', sans-serif;
        font-size: 14px;
    }
    .reach-us-email strong{
        text-decoration: underline dotted;
    }
    .sidebar-menu-container{
position: absolute;
    top: 0;
    right: -300px;
    bottom: 0;
    width: 300px;
    height: 100%;
    overflow: auto;
    padding: 41px;
    background-color: #383838;
    /*display: none;*/
    }
    /*.menu-open .sidebar-menu-container{
        display: block;
    }*/
    .sidebar-menu-container .menu-title{
           margin-top: 8px;
    margin-bottom: 31px;
    font-size: 14px;
    }
        .sidebar-menu-container .reach-us-email{
    font-size: 13px;
        }
    .home-container{
        display: flex;
   overflow: hidden;
    }
    .menu-title {
    font-size: 15px;
    font-weight: 600;
    letter-spacing: 2px;
    text-transform: uppercase;
    color: #ddd;
}
.menu-overlay{
    position: absolute;
    left:0;
    right:300px;
    top:0;
    bottom:0;
    background-color: rgba(0,0,0,0.01);
    z-index: 1;
   display: none;
   transition:all 0.5s;
}
.menu-open .menu-overlay{
    display: block;
}
@media only screen and (max-width:815px){
    .main-heading {
    font-size: 79px;
}
.welcome-text {
    font-size: 18px;
    margin-bottom: 25px;
}
}
@media only screen and (max-width:767px){
    .home-header {
    background: rgba(0,0,0,0.5);
}
}
@media only screen and (max-width:575px){
    .main-heading {
    font-size: 79px;
    padding:0 15px;
}
.welcome-text {
    font-size: 18px;
    margin-bottom: 25px;
    padding:0 15px;
}
.sidebar-close-btn{
    display: block;
}

}
@media only screen and (max-width:480px){
    .main-heading {
    font-size: 68px;
    padding:0 15px;
}
.home-header {
    padding: 16px 15px;
}
.menu-listing li {
    padding: 7px 10px;
}

}
@media only screen and (max-width:810px) and (orientation: landscape){
.home-body {
    align-items: flex-start;
    overflow: auto;
    padding: 35px 0;
}
}
</style>
